const SUPPORTED_BROWSER_REGEX = /Safari|Chrome|Firefox|iPhone|iPad/;
const UNSUPPORTED_BROWSER_REGEX = /Edge|MSIE|rv:11/;

export const getIsSupportedUserAgent = (userAgent = '') =>
    SUPPORTED_BROWSER_REGEX.test(userAgent) && !UNSUPPORTED_BROWSER_REGEX.test(userAgent);
